import { Box, styled, Typography } from '@mui/material';

import { LayoutDropdown, NavigationMenu } from '#features';

const PREFIX = 'TSMED-LayoutManager-EmptySectionPlaceholder';

export const emptySectionPlaceholderClasses = {
  root: `${PREFIX}-root`,
  message: `${PREFIX}-message`,
  row: `${PREFIX}-row`,
};

const Root = styled(Box)(({ theme }) => ({
  [`&.${emptySectionPlaceholderClasses.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.mapBlue[800],
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    textAlign: 'center',
    position: 'relative',
  },
  [`& .${emptySectionPlaceholderClasses.message}`]: {
    color: theme.palette.common.white,
    opacity: 0.7,
    fontSize: '14px',
    maxWidth: '220px',
    lineHeight: 1.4,
  },

  [`.${emptySectionPlaceholderClasses.row}`]: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

export interface EmptySectionPlaceholderProps {
  testId?: string;
}

/**
 * Placeholder shown in RENDER mode when a section has no visible widgets.
 * Displays a message indicating the section is empty.
 */
export const EmptySectionPlaceholder = ({
  testId,
}: EmptySectionPlaceholderProps) => (
  <Root
    className={emptySectionPlaceholderClasses.root}
    data-testid={testId || 'empty-section-placeholder'}
  >
    <Box className={emptySectionPlaceholderClasses.row}>
      <LayoutDropdown />
      <NavigationMenu value={location.pathname} />
    </Box>

    <Typography className={emptySectionPlaceholderClasses.message}>
      No widgets in this section
    </Typography>
  </Root>
);
